<template>
  <div class="jumbotron jumbotron-fluid text-white d-flex">
    <div class="container-fluid my-auto text-center">
      <h1 class="" style="font-size: 39px; font-weight: 500;">Peterbilt Operating Costs Calculator</h1>
      <h2 class="text-white" style="font-size: 16px; font-weight: 500;">Make an informed decision between diesel and electric.</h2>
    </div>
  </div>
  <div class="landing-page">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 mt-3 mb-5">
          <p class="intro-p lead my-0">
            The Peterbilt Operating Costs Calculator (OCC) is designed to help you calculate and compare operating costs for commercial trucks. The tool calculates individual trucking expenses for power consumption and fuel costs to help you decide between a diesel and electric truck for nearly every type of configuration and consideration. 
            <br>
            Determine your commercial vehicle's running costs now.
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <h2 class="heading-2 pt-4">Select Powertrain:</h2>
        </div>

        <div class="col-6">
          <div class="text-center fuel-select" id="diesel-vehicles">
            <img :src="`${imagePath}/oil-icon.png`" alt="" class="img-fluid">
            <p class="sub-heading">Diesel</p>
          </div>
        </div>

        <div class="col-6">
          <div class="text-center fuel-select" id="electric-vehicles">
            <img :src="`${imagePath}/electirc-icon.png`" alt="" class="img-fluid">
            <p class="sub-heading">Electric</p>
          </div>
        </div>

      </div>

      <div class="row vehicle-select-cards disabled"> 
        <div class="col-sm-12">
          <h2 class="heading-2">Select Vehicle:</h2>
        </div>

        <div v-for="(vehicle, index) in vehicleList.twoTwenty" :key="index" :class="[vehicle.fuel.type == 'electric' ? 'col-sm-4 electric-vehicle' : 'col-sm-4 diesel-vehicle']">
          <div class="vehicle-card" data-vehicle-name="twoTwenty" @click="getVehicleData(vehicleList.twoTwenty, vehicle.fuel.type)">
            <div class="d-flex justify-content-between">
              <div v-if="vehicle.productInfo">
                <p class="d-flex modal-link" data-toggle="modal" :data-target="'#L'+vehicle.name" @click="trackProductInfoModal(vehicle)"><span class="material-icons-outlined">info</span><span>&nbsp;Product Info</span></p>
              </div>
              <p class="text-uppercase fuel-type-heading">{{ vehicle.fuel.type }}</p>
            </div>
            <div class="image-container">
              <img :src="vehicle.icon" :alt="vehicle.name" class="img-fluid">
            </div>
            <div class="banner-default-active">
              <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
            </div>

            
            <div class="text-center">
              <p>{{ vehicle.class }}</p>
            </div>

          </div>
        </div>
        
        <div v-for="(vehicle, index) in vehicleList.fiveTwenty" :key="index" :class="[vehicle.fuel.type == 'electric' ? 'col-sm-4 electric-vehicle' : 'col-sm-4 diesel-vehicle']">
          <div class="vehicle-card" data-vehicle-name="twoTwenty" @click="getVehicleData(vehicleList.fiveTwenty, vehicle.fuel.type)">
            <div class="d-flex justify-content-between">
              <div v-if="vehicle.productInfo">
                <p class="d-flex modal-link" data-toggle="modal" :data-target="'#L'+vehicle.name" @click="trackProductInfoModal(vehicle)"><span class="material-icons-outlined">info</span><span>&nbsp;Product Info</span></p>
              </div>
              <p class="text-uppercase fuel-type-heading">{{ vehicle.fuel.type }}</p>
            </div>
            <div class="image-container">
              <img :src="vehicle.icon" :alt="vehicle.name" class="img-fluid">
            </div>
            <div class="banner-default-active">
              <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
            </div>

            
            <div class="text-center">
              <p>{{ vehicle.class }}</p>
            </div>
          </div>
        </div>

        <div v-for="(vehicle, index) in vehicleList.fiveSeventyNine" :key="index" :class="[vehicle.fuel.type == 'electric' ? 'col-sm-4 electric-vehicle' : 'col-sm-4 diesel-vehicle']">
          <div class="vehicle-card" data-vehicle-name="twoTwenty" @click="getVehicleData(vehicleList.fiveSeventyNine, vehicle.fuel.type)">
            <div class="d-flex justify-content-between">
              <div v-if="vehicle.productInfo">
                <p class="d-flex modal-link" data-toggle="modal" :data-target="'#L'+vehicle.name" @click="trackProductInfoModal(vehicle)"><span class="material-icons-outlined">info</span><span>&nbsp;Product Info</span></p>
              </div>
              <p class="text-uppercase fuel-type-heading">{{ vehicle.fuel.type }}</p>
            </div>
            <div class="image-container">
              <img :src="vehicle.icon" :alt="vehicle.name" class="img-fluid">
            </div>
            <div class="banner-default-active">
              <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
            </div>

            
            <div class="text-center">
              <p>{{ vehicle.class }}</p>
            </div>
          </div>
        </div>

        
      </div>

      <div class="row">
        <div class="col-sm-12 links" id="scroll-target">
          <div class="overlay"></div>

          <div id="electric-link" class="text-center">
            <router-link to="/electric/fuel-costs" class="big-link heading-2 text-center" @click="trackCaclulateNow('electric')">Calculate Now <img :src="`${imagePath}/arrow.png`" alt=""></router-link>
          </div>

          <div id="diesel-link" class="text-center">
            <router-link to="/diesel/fuel-costs" class="big-link heading-2 text-center" @click="trackCaclulateNow('diesel')">Calculate Now <img :src="`${imagePath}/arrow.png`" alt=""></router-link>
          </div>

        </div>
      </div>
    </div>

    <!-- TODO move into own compenent, set up props -->
    <div v-for="(vehicle, index) in vehicleList.twoTwenty" :key="index">

      <div :id="'L'+vehicle.name" class="modal-summary modal fade" tabindex="-1">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title font-heading text-uppercase">Peterbilt {{ vehicle.name }} Product Info</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="material-icons" aria-hidden="true">clear</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="container">
                <div class="row">
                
                <div class="col-sm-6 text-center">
                  <div class="image-container text-center my-2">
                    <img v-bind:src="vehicle.icon" alt="Peterbilt {{ vehicle.name }}" class="img-fluid">
                  </div>
                  <div class="banner-default-active my-3">
                    <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
                  </div>

                  <div class="btn btn-block btn-outline-primary video-modal-launch play-video" data-toggle="modal" data-target="#video-modal" :data-src="vehicle.videoLink" :data-title="'Peterbilt '+ vehicle.name " @click="trackVideo(vehicle.name)">
                    Play Video
                  </div>
                </div>

                <div class="col-sm-6 right-side">
                  
                  <div class="d-flex justify-content-between mb-4 info-intro">
                    <span class="text-uppercase active fuel-type">{{ vehicle.fuel.type }}</span>
                    <span>{{ vehicle.descriptionSubHead }}</span>
                  </div>

                  <hr>

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>{{ vehicle.rangeType }}</span>
                    <span>{{ vehicle.range}}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>Charging Time</span>
                    <span>{{ vehicle.chargingTime }}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <p class="text-left mb-5">{{ vehicle.descriptionDetails }}</p>

                  <div class="row">

                    <div class="col-lg-4 my-auto">
                      <p class="text-uppercase resource-copy">Resources:</p>
                    </div>

                    <div class="col-lg-8">
                      <a :href="vehicle.resources" download class="download-link d-block" @click="trackProductInfoResourceDownload(vehicle)">
                        <div class="d-flex justify-content-between border align-items-center">
                          <div class="p-3 mb-0">
                            <span>{{ vehicle.pdfName }}</span><br>
                            <span><small>{{ vehicle.pdfSize }}</small></span>
                          </div>
                          <div>
                            <img :src="`${imagePath}/download.svg`" width="30" height="30" class="mr-3">
                          </div>
                        </div>
                      </a>
                    </div>
                  
                  </div>



                </div>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <div v-for="(vehicle, index) in vehicleList.fiveTwenty" :key="index">

      <div :id="'L'+vehicle.name" class="modal-summary modal fade" tabindex="-1">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title font-heading text-uppercase">Peterbilt {{ vehicle.name }} Product Info</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="material-icons" aria-hidden="true">clear</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="container">
                <div class="row">
                
                <div class="col-sm-6 text-center">
                  <div class="image-container text-center my-2">
                    <img v-bind:src="vehicle.icon" alt="Peterbilt {{ vehicle.name }}" class="img-fluid">
                  </div>
                  <div class="banner-default-active my-3">
                    <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
                  </div>

                  <div class="btn btn-block btn-outline-primary video-modal-launch play-video" data-toggle="modal" data-target="#video-modal" :data-src="vehicle.videoLink" :data-title="'Peterbilt '+ vehicle.name " @click="trackVideo(vehicle.name)">
                    Play Video
                  </div>
                </div>

                <div class="col-sm-6 right-side">
                  
                  <div class="d-flex justify-content-between mb-4 info-intro">
                    <span class="text-uppercase active fuel-type">{{ vehicle.fuel.type }}</span>
                    <span>{{ vehicle.descriptionSubHead }}</span>
                  </div>

                  <hr>

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>{{ vehicle.rangeType }}</span>
                    <span>{{ vehicle.range}}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>Charging Time</span>
                    <span>{{ vehicle.chargingTime }}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <p class="text-left mb-5">{{ vehicle.descriptionDetails }}</p>

                  <div class="row">

                    <div class="col-lg-4 my-auto">
                      <p class="text-uppercase resource-copy">Resources:</p>
                    </div>

                    <div class="col-lg-8">
                      <a :href="vehicle.resources" download class="download-link d-block" @click="trackProductInfoResourceDownload(vehicle)">
                        <div class="d-flex justify-content-between border align-items-center">
                          <div class="p-3 mb-0">
                            <span>{{ vehicle.pdfName }}</span><br>
                            <span><small>{{ vehicle.pdfSize }}</small></span>
                          </div>
                          <div>
                            <img :src="`${imagePath}/download.svg`" width="30" height="30" class="mr-3">
                          </div>
                        </div>
                      </a>
                    </div>
                  
                  </div>



                </div>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 
    <div v-for="(vehicle, index) in vehicleList.fiveSeventyNine" :key="index">

      <div :id="'L'+vehicle.name" class="modal-summary modal fade" tabindex="-1">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title font-heading text-uppercase">Peterbilt {{ vehicle.name }} Product Info</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span class="material-icons" aria-hidden="true">clear</span>
              </button>
            </div>
            <div class="modal-body p-0">
              <div class="container">
                <div class="row">
                
                <div class="col-sm-6 text-center">
                  <div class="image-container text-center my-2">
                    <img v-bind:src="vehicle.icon" alt="Peterbilt {{ vehicle.name }}" class="img-fluid">
                  </div>
                  <div class="banner-default-active my-3">
                    <img :src="vehicle.bannerAlt" :alt="vehicle.name" class="img-fluid d-flex mx-auto">
                  </div>

                  <div class="btn btn-block btn-outline-primary video-modal-launch play-video" data-toggle="modal" data-target="#video-modal" :data-src="vehicle.videoLink" :data-title="'Peterbilt '+ vehicle.name " @click="trackVideo(vehicle.name)">
                    Play Video
                  </div>
                </div>

                <div class="col-sm-6 right-side">
                  
                  <div class="d-flex justify-content-between mb-4 info-intro">
                    <span class="text-uppercase active fuel-type">{{ vehicle.fuel.type }}</span>
                    <span>{{ vehicle.descriptionSubHead }}</span>
                  </div>

                  <hr>

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>{{ vehicle.rangeType }}</span>
                    <span>{{ vehicle.range}}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <div class="d-flex justify-content-between mt-4 mb-3" v-if="vehicle.range">
                    <span>Charging Time</span>
                    <span>{{ vehicle.chargingTime }}</span>
                  </div>

                  <hr v-if="vehicle.range">

                  <p class="text-left px-xl-4 mb-5">{{ vehicle.descriptionDetails }}</p>

                  <div class="row">

                    <div class="col-lg-4 my-auto">
                      <p class="text-uppercase resource-copy">Resources:</p>
                    </div>

                    <div class="col-lg-8">
                      <a :href="vehicle.resources" download class="download-link d-block" @click="trackProductInfoResourceDownload(vehicle)">
                        <div class="d-flex justify-content-between border align-items-center">
                          <div class="p-3 mb-0">
                            <span>{{ vehicle.pdfName }}</span><br>
                            <span><small>{{ vehicle.pdfSize }}</small></span>
                          </div>
                          <div>
                            <img :src="`${imagePath}/download.svg`" width="30" height="30" class="mr-3">
                          </div>
                        </div>
                      </a>
                    </div>
                  
                  </div>



                </div>

              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> 


    <!-- VIDEO MODAL -->
    <div id="video-modal" ref="videoModal" class="modal-summary modal fade" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-heading text-uppercase">Peterbilt video Product Info</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span class="material-icons" aria-hidden="true">clear</span>
            </button>
          </div>
          <div class="modal-body p-0">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe class="embed-responsive-item" src="" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import $ from 'jquery'
  import vehicleList from '../services/vehicleList'

  export default {
    name: 'LandingPage',
    components: {
    },  
    data() {
      return {
        vehicleList : vehicleList,
        activeVehicle: {},
        imagePath: process.env.VUE_APP_ASSET_LOCATION
      }
    },
    mounted() {

      $('.video-modal-launch').on('click', function() {
        var modal = $('#video-modal')
        modal.find('iframe').attr('src', $(this).data('src'))
        modal.find('.modal-title').text($(this).data('title'))
      })

      $('#video-modal').on('hide.bs.modal', function (e) {
        $(this).find('iframe').attr('src','')
        $(this).find('.modal-title').text('')
      })

      $('.fuel-select').removeClass('active');
      $('.fuel-select').on('click', function () {
        $('.fuel-select').removeClass('active');
        $('.vehicle-select-cards').removeClass('disabled');

        $(this).addClass('active');

        if($('#diesel-vehicles').hasClass('active')) {
          $('#diesel-link, .diesel-vehicle').show();
          $('#electric-link, .electric-vehicle').hide();

          // Tracking
          window.gtag('event', 'Click', {
            'event_category': 'Cost Calculator - Powertrain',
            'event_label': 'Diesel'
          })

        } else {
          $('#diesel-link, .diesel-vehicle').hide();
          $('#electric-link, .electric-vehicle').show();

          // Tracking
          window.gtag('event', 'Click', {
            'event_category': 'Cost Calculator - Powertrain',
            'event_label': 'Electric'
          })
        }

        
      });

      $('.vehicle-card').on('click', function() {
        if(!$('.vehicle-select-cards').hasClass('disabled')) {
          $('.vehicle-card').removeClass('active')
          $(this).addClass('active')
          $('.overlay').hide();
        }
      });

      // Video modal from info modal causes a conflict in closing. Programatically add the 'modal-open' class to keep the parent modal usable
      $(this.$refs.videoModal).on('hidden.bs.modal', this.preventModalClose)


      // Tracking
      window.gtag('event', 'page_view', {
        page_title: 'Cost Calculator - Home',
        page_location: '/'
      })

    },
    methods: {
      scrollToSection(event) {
        event.preventDefault();
        const element = document.getElementById('scroll-target');
        
        if (element) {
          // Get the top position of the element
          const top = element.offsetTop;

          // Smoothly scroll to the element
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          });
        }
      },
      getVehicleData(info, fuelType) {
        this.activeVehicle = info

        // Set both fuel types of vehicle in storage
        localStorage.setItem('USDtoCAD', 1.266485552)
        localStorage.setItem('calculatorVehicleElectric', JSON.stringify(info.electric))
        localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(info.diesel))
        localStorage.setItem('activeFuelType', fuelType)

        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Vehicle',
          'event_label': info[fuelType].name
        })
      },
      preventModalClose() {
        setTimeout(() => {
          document.body.classList.add('modal-open')
        }, 100)
      },
      trackProductInfoModal(vehicle) {
        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Vehicle Info',
          'event_label': vehicle.name
        })
      },
      trackVideo(vehicleName) {
        // Tracking
        window.gtag('event', 'Play', {
          'event_category': 'Cost Calculator - Vehicle Video',
          'event_label': vehicleName
        })
      },
      trackProductInfoResourceDownload(vehicle) {
        // Tracking
        window.gtag('event', 'Download', {
          'event_category': 'Cost Calculator - Vehicle Resource',
          'event_label': vehicle.name
        })
      },
      trackCaclulateNow(fuel) {
        // Tracking
        window.gtag('event', 'Calculate Now', {
          'event_category': 'Cost Calculator - Calculate Now',
          'event_label': this.activeVehicle[fuel].name
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .electric-vehicle {
    .banner-default-active {
      img {
        max-width: 84px;
      }
    }
  }
  .disabled {
    opacity: .4;
  }

  .modal-link {
    cursor: pointer;
  }

  .play-video {
    max-width: 60%;
    margin: auto;
    margin-bottom: 3rem;
  }

  .modal {
    .right-side {
      padding: 3rem;
    }

    .fuel-type {
      font-weight: 600;
    }

    .resource-copy {
      font-weight: 600;
      margin-bottom: 0;
    }
    .download-link {
      color: black;
      text-decoration: none;
      &:hover {
        > div {
          border-bottom: 1px solid #C00102 !important;
        }
      }
    }
  }
</style>